import React from "react";
import { View } from "@aws-amplify/ui-react";

export function Layout({ children }) {
  return <View padding="0px 16px 0px 16px">{children}</View>;
}
